import { Button, IconButton } from "@mui/material";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import DeleteIcon from "@mui/icons-material/Delete";
import Table from "../../components/Table";

import useAuth from "../../models/auth/useAuth";
import useWorkers from "../../models/workers/useWorkers";
import SwitchInput from "../../components/Switch";
import InvitationModal from "./InvitationModal";

import "./styles.scss";

const WorkersList = () => {
  const {
    user: { restaurant_worker },
  } = useAuth();
  const { workers, fetchWorkers, setIsAdmin, deleteWorker } = useWorkers();
  const [showInvitationModal, setShowInvitationModal] = useState(false);

  const handleSetIsAdmin = async (id, isAdmin) => {
    try {
      await setIsAdmin(id, isAdmin);
      isAdmin
        ? toast.success("Este trabajador ahora es administrador.")
        : toast.success("Este trabajador ya no es administrador");
    } catch (e) {
      toast.error("UPS! Ha ocurrido un error.");
    }
  };

  const handleDeleteWorker = async (id) => {
    try {
      await deleteWorker(id);
      toast.success("Trabajador eliminado correctamente.");
    } catch (e) {
      toast.error("UPS! Ha ocurrido un error.");
    }
  };

  const tableColumns = [
    { headerName: "Email", field: "email", flex: 2, sortable: false },
    {
      headerName: "Admin",
      field: "is_admin",
      sortable: false,
      renderCell: ({ row }) => (
        <SwitchInput
          checked={row.is_admin}
          onChange={(_, is_admin) => handleSetIsAdmin(row.id, is_admin)}
          disabled={restaurant_worker.id == row.id}
        />
      ),
    },
    {
      headerName: "",
      type: "actions",
      field: " ",
      sortable: false,
      renderCell: ({ row }) => (
        <IconButton
          onClick={() => handleDeleteWorker(row.id)}
          disabled={restaurant_worker.id == row.id}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  useEffect(() => {
    fetchWorkers();
  }, [restaurant_worker]);

  return (
    <>
      <div className="WorkersList">
        <div className="WorkersList__header">
          <h1>Listado de trabajadores</h1>
          <Button
            variant="contained"
            onClick={() => setShowInvitationModal(true)}
          >
            Invitar trabajador
          </Button>
        </div>
        <Table columns={tableColumns} data={workers} hidePagination />
      </div>
      <InvitationModal
        isOpen={showInvitationModal}
        onClose={() => setShowInvitationModal(false)}
      />
    </>
  );
};

export default WorkersList;
